import React from "react";
import { useNavigate } from "react-router-dom";

// Real <a href> so right-click → Open in new tab / Cmd-click / middle-click work; plain click stays an SPA navigation.
export function CaseLink({ recordId, children, className, testid, onClick }) {
  const navigate = useNavigate();
  const href = `/cases/${recordId}`;
  return (
    <a href={href} data-testid={testid} className={className}
      onClick={(e) => {
        e.stopPropagation();
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
        e.preventDefault(); onClick?.(); navigate(href);
      }}
      onAuxClick={(e) => e.stopPropagation()}>
      {children}
    </a>
  );
}
